import React from 'react';
import PropTypes from 'prop-types';
import pallet from 'constants/colors';

import { FormattedMessage } from 'react-intl';

const styles = {
  loadingContainer: {
    padding: '24px 18px',
    width: 'calc(100% - 36px)',
    height: 'calc(100% - 48px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  textError: {
    borderBottom: `4px solid ${pallet.errorColor}`,
    padding: 8,
    fontSize: 20,
    marginBottom: 12,
  },
  text: {
    borderBottom: `4px solid ${pallet.primary1Color}`,
    padding: 8,
    fontSize: 20,
    marginBottom: 12,
  },
  textWarning: {
    borderBottom: `4px solid ${pallet.warningColor}`,
    padding: 8,
    fontSize: 20,
    marginBottom: 12,
  },
  textSuccess: {
    borderBottom: `4px solid ${pallet.successColor}`,
    padding: 8,
    fontSize: 20,
    marginBottom: 12,
  },
};

const TMessage = ({
  type, message, children, style, values,
}) => {
  let content = (
    <span style={styles.text}>
      <FormattedMessage id={message} values={values} />
    </span>
  );

  if (type === 'error') {
    content = (
      <span style={styles.textError}>
        <FormattedMessage id={message} values={values} />
      </span>
    );
  }

  if (type === 'warning') {
    content = (
      <span style={styles.textWarning}>
        <FormattedMessage id={message} values={values} />
      </span>
    );
  }

  if (type === 'success') {
    content = (
      <span style={styles.textSuccess}>
        <FormattedMessage id={message} values={values} />
      </span>
    );
  }

  return (
    <div style={{ ...styles.loadingContainer, ...style }}>
      {content}
      {children}
    </div>
  );
};

TMessage.propTypes = {
  message: PropTypes.string.isRequired,
  children: PropTypes.node,
  style: PropTypes.object,
  type: PropTypes.oneOf(['error', 'warning', 'success']),
  values: PropTypes.object,
};

TMessage.defaultProps = {
  style: {},
  values: {},
};

export default TMessage;



// WEBPACK FOOTER //
// ./src/containers/tiles/TMessage.js